import { useState, useEffect, useCallback, useRef } from "react";
import {
    getResolvedImageSrc,
    markFallbackUsed,
    toR2MirrorUrl,
} from "../../utils/imageUrl";

export function useResilientImageSrc(originalSrc) {
    const [src, setSrc] = useState(() => getResolvedImageSrc(originalSrc));
    const [failed, setFailed] = useState(false);
    const originalRef = useRef(originalSrc);

    useEffect(() => {
        originalRef.current = originalSrc;
        setSrc(getResolvedImageSrc(originalSrc));
        setFailed(false);
    }, [originalSrc]);

    const handleError = useCallback((event) => {
        const mirror = toR2MirrorUrl(originalRef.current);
        const img = event?.currentTarget;

        if (mirror && img?.dataset?.r2Fallback !== "1") {
            img.dataset.r2Fallback = "1";
            markFallbackUsed(originalRef.current, mirror);
            setSrc(mirror);
            img.src = mirror;
            return;
        }

        if (mirror && !img && src !== mirror) {
            markFallbackUsed(originalRef.current, mirror);
            setSrc(mirror);
            return;
        }

        setFailed(true);
    }, [src]);

    return { src, handleError, failed };
}
